/* Interactive MCQ quiz behaviour for blog posts (India Book Mart) */
(function () {
  function initQuiz(root) {
    var questions = root.querySelectorAll('.ibm-quiz__q');
    questions.forEach(function (q) {
      var correct = (q.getAttribute('data-answer') || '').trim().toUpperCase();
      var opts = q.querySelectorAll('.ibm-quiz__opt');
      opts.forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        if (!input) return;
        input.addEventListener('change', function () {
          if (q.classList.contains('is-answered')) return;
          var chosen = (input.value || '').trim().toUpperCase();
          q.classList.add('is-answered');

          // Mark every option
          opts.forEach(function (o) {
            var oi = o.querySelector('input[type="radio"]');
            var val = oi ? (oi.value || '').trim().toUpperCase() : '';
            if (val === correct) {
              o.classList.add('is-correct');
            }
            if (o === opt && chosen !== correct) {
              o.classList.add('is-wrong');
            }
          });

          // Result line
          var result = q.querySelector('.ibm-quiz__result');
          if (chosen === correct) {
            q.classList.add('is-correct-answer');
            if (result) result.textContent = '✔ Correct!';
          } else {
            q.classList.add('is-wrong-answer');
            if (result) result.textContent = '✘ Not quite — the correct answer is ' + correct + '.';
          }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('.ibm-quiz').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
